import React, { Fragment } from 'react'
import { NonIdealState, Button, Intent, InputGroup, H3 } from "@blueprintjs/core";
import RessourceFullscreenable from '../../Sequences/RessourceFullscreenable'



const FixedChannel = ({ onOpenDialogFixed, fixedChannel, handleDeleteCriteria }) => {


    if (fixedChannel && fixedChannel.downloadURL)
        return (
            <Fragment>
                <H3 className="text-center margin-bottom-medium">Fixed Channel:</H3>
                <div className="margin-bottom-large">
                    <div className='margin-img-lg'></div>
                    <div className='right-container'>
                        <RessourceFullscreenable
                            downloadURL={fixedChannel.downloadURL}
                            index={100}
                            imageSize={1}
                            handleDeleteResource={handleDeleteCriteria}
                            id={fixedChannel.id}
                            fileNumber={1}
                        />
                    </div>
                    <div></div>
                    <div className='align-center'>
                    </div>
                    <div className="right-container">
                        < div>
                            <InputGroup
                                className='images-inputs'
                                name="name"
                                disabled={true}
                                defaultValue={fixedChannel.name}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        )

    return (
        <div className='margin-bottom-large'>
            <NonIdealState
                icon="selection"
                title="No fixed channel"
                description="You did not add fixed channel yet"
                action={<Button
                    intent={Intent.SUCCESS}
                    // disabled={criterias.length >= 5}
                    rightIcon="add"
                    text="Add Fixed Channel"
                    onClick={onOpenDialogFixed} />} />
        </div>
    )
}

export default FixedChannel
